export const ASSIGN_TO_FILE = `
  mutation AssignToFile($input: AssignToFileInput!) {
    media {
      assignToFile(input: $input) {
        success
        message
      }
    }
  }
`;